'use strict';

wbApp.controller('RentsSelectCategoryCtrl', ['$scope', '$http', '$window', 'urlUtils', 'classroomSvc', 'rentCategorySvc', 'rentCategoryGroupSvc', 'shoppingCartSvc',
function ($scope, $http, $window, urlUtils, classroomSvc, rentCategorySvc, rentCategoryGroupSvc, shoppingCartSvc) {

    $scope.tabs = [];
    $scope.categories = [];

    var placesWithRents = classroomSvc.getAllActiveAsync(null, false, false, true);
    $scope.place = {};

    var selectedCategoryGroupId = urlUtils.getQueryParams()['rentCategoryGroupId'];
    $scope.selectedCategoryGroup = null;

    function PrepareTabs() {
        placesWithRents.$promise.then(function () {
            for (var i = 0; i < placesWithRents.length; i++) {
                var place = placesWithRents[i];
                $scope.tabs.push({
                    title: place.name,
                    placeId: place.id,
                    template: "rents/select-category-tab.html",
                });
            }

            if (placesWithRents.length) {
                switchToCorrectTab();
            }
        });
    }

    PrepareTabs();

    function loadRentData(placeId)
    {
        if (!!selectedCategoryGroupId) {
            $scope.groups = [];
            rentCategorySvc.getAllByPlace(placeId).$promise.then(function (data) {
                $scope.categories = _.filter(data, function (category) {
                    return category.rentCategoryGroupId == selectedCategoryGroupId;
                });
            });
            $scope.selectedCategoryGroup = rentCategoryGroupSvc.getById(selectedCategoryGroupId);
        } else {
            rentCategorySvc.getAllByPlace(placeId).$promise.then(function (data) {
                $scope.categories = _.filter(data, function (category) {
                    return !category.rentCategoryGroupId;
                });
            });
            $scope.groups = rentCategoryGroupSvc.getAllByPlace(placeId);
        }

        $scope.cart = shoppingCartSvc.loadShoppingCart(placeId);
    }

    $scope.cart = {};

    $scope.rentCategoryListOptions = {
        bindingOptions: {
            dataSource: "categories"
        }
    };

    function switchToCorrectTab() {
        placesWithRents.$promise.then(function () {
            var placeIdStr = urlUtils.getQueryParams()['placeId'];
            if (!!placeIdStr) {

                var placeId = Number(placeIdStr);
                // find correct tab
                var tabIndexToActivate = _.findIndex($scope.tabs, { placeId: placeId });
                if (tabIndexToActivate !== -1 && $scope.tabs.activeTab !== tabIndexToActivate) {
                    $scope.tabs.activeTab = tabIndexToActivate;
                    return;
                }
            }

            urlUtils.setUrlParam("placeId", null);
            $scope.tabs.activeTab = 0;
        });
    }

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {

        if (newValue !== null && newValue !== undefined) {

            placesWithRents.$promise.then(function () {                
                var placeId = $scope.tabs[newValue].placeId;
                $scope.place = _.find(placesWithRents, { id: placeId });

                loadRentData(placeId);

                urlUtils.setUrlParam("placeId", placeId);
            });
        }
    });


}]);